import axios from "axios";

const fbserviceAPI2 = axios.create({
  baseURL: "https://granaextra.top:3456",
  headers: { "Content-Type": "application/json", charset: "utf-8" },
});

export default fbserviceAPI2;
